import instacart from 'legacy/common/instacart'
import { type PartnerAndRetailerId } from 'utils/routing/params.types'
import { type SearchApiFetchAislesResponse } from 'legacy/common/utils/catalog/aisles/aisles.types'

interface FetchAislesApiProps extends PartnerAndRetailerId {
  departmentId: number
}

export const fetchAisles = async ({ retailerId, partnerId, departmentId }: FetchAislesApiProps) =>
  instacart.go.get<SearchApiFetchAislesResponse>(
    `/v1/partners/${partnerId}/warehouses/${retailerId}/departments/${departmentId}/aisles`
  )
